import { Outlet } from "react-router";

import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const BillingMeetingsLayout = () => {
    const navList = useNav();
    let { billingMeetingBottomNav, topBillingNav } = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={billingMeetingBottomNav} topTabs={topBillingNav} />
            <Outlet />
        </div>
    );
}

export default BillingMeetingsLayout;